import { onActionError, onDeleteError, onFormError } from '../../core/utils/hooks'
import { notification } from 'antd'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  load,
  fetchWithPagination,
  downloadPurchaseOrder,
  acceptPurchaseOrder,
  questionPurchaseOrder,
  addInvoice,
  removeInvoice
} from '../../api/vendor/purchaseOrder'

const key = 'vendor.purchaseOrder'

export const useList = (queryParams) => {
  return useQuery({
    queryKey: [key, queryParams],
    queryFn: () => fetchWithPagination(queryParams)
  })
}

export const useFetch = (id) => {
  return useQuery({
    queryKey: [key, id],
    queryFn: () => load(id),
    onError: onActionError
  })
}

export const useAcceptPurchaseOrder = (id) => {
  const queryClient = useQueryClient()
  const action = () => acceptPurchaseOrder(id)
  return useMutation({
    mutationFn: action,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'PurchaseOrder was accepted!'
      })
    },
    onError: onActionError
  })
}

export const useQuestionPurchaseOrder = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => questionPurchaseOrder(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The questions have been sent!'
      })
    },
    onError: onActionError
  })
}

export const useDownload = () => {
  return useMutation({
    mutationFn: downloadPurchaseOrder,
    onSuccess: () => {

    },
    onError: onActionError
  })
}

export const usePostInvoice = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => addInvoice(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The invoice has been uploaded!'
      })
    },
    onError: onFormError
  })
}

export const useRemoveInvoice = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => removeInvoice(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Deleted',
        description: 'The invoice was deleted'
      })
    },
    onError: onDeleteError
  })
}
